import axios from "axios";

const request = axios.create({
  baseURL: "https://api.alfares.cloud"
});

export default request;
